import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserRolesState } from './user-roles.models';

export const selectUserRolesState = createFeatureSelector<UserRolesState>('userRoles');

export const selectUserRolesByGuid = (userGuid: string) =>
  createSelector(selectUserRolesState, (state) => state.roles[userGuid] || null);

export const selectUserRolesLoading = createSelector(selectUserRolesState, (state) => state.loading);

export const selectUserRolesError = createSelector(selectUserRolesState, (state) => state.error);

export const selectCurrentCertifyRole = createSelector(selectUserRolesState, (state) => state.currentCertifyRole);

export const selectLastRoles = createSelector(selectUserRolesState, (state) => state.lastRoles);
